import { useReducer } from 'react';
function reducer(state, action) {
    var _a;
    switch (action.type) {
        case 'open_main': {
            return Object.assign(Object.assign({}, state), { mainIsOpen: true, secondaryIsOpen: false });
        }
        case 'open_secondary': {
            return {
                mainIsOpen: false,
                secondaryIsOpen: true,
                secondaryItems: (_a = action.data) !== null && _a !== void 0 ? _a : [],
            };
        }
        case 'close_all': {
            return Object.assign(Object.assign({}, state), { mainIsOpen: false, secondaryIsOpen: false });
        }
        default: {
            return state;
        }
    }
}
const useDrawerListReducer = () => {
    return useReducer(reducer, {
        mainIsOpen: false,
        secondaryIsOpen: false,
        secondaryItems: [],
    });
};
export default useDrawerListReducer;
